import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[h3ClickNSpin]',
  standalone: false,
})
export class ClickNSpinDirective {
  @Input() h3ClickNSpin?: () => PromiseLike<any> | void;

  private $el: JQuery;

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
  }

  @HostListener('click')
  onClick() {
    const restore = legacyHideAndShowProgress(this.$el);
    try {
      Promise.resolve(this.h3ClickNSpin?.()).then(restore, restore);
    } catch (ex) {
      restore();
      throw ex;
    }
  }
}

function legacyHideAndShowProgress($el: JQuery) {
  const original = $($el);
  original.hide();
  const placeholder = $(
    '<button class="loading-button" disabled="disabled">&nbsp;</button>',
  )
    .addClass(original.attr('class')!)
    .css('width', original.css('width'));
  original.parent().find('.loading-button').remove();
  original.before(placeholder);
  return () => {
    placeholder.remove();
    original.show();
  };
}
